import { ILocationBilling } from '@ready/dashboardv2api.contracts';

export const cachedBilling = {} as ILocationBilling;
